<div class = "container">
  <h3>{{type?.name}}</h3>
  <div class= "lineInfo">
    @if (showImage) {
      <div class="image">
        <img src="/files/{{imageDirectory}}/{{type[imageFieldName]}}" alt="" defaultImg>
      </div>
    }
    <div [innerHTML]="type.content" id="tinymce">
    </div>
  </div>
</div>
@if (button) {
  <button mat-raised-button color="primary" (click)="close()" matRipple>
    {{ 'INTERFACE|Wybierz' | translate }}
  </button>
}

